  //Over mouse
  function overmouseimage(element){
    
    var Idimage_ = document.getElementById(element.id.replace("variant", "imagen"));  
    var varianteimage_ = document.getElementById(element.id);  
    Idimage_.srcset =  element.getAttribute("data-variant-image") ;
    
  };

  //Out mouse
  function outmouseimage(element){
    var Idimage_ = document.getElementById(element.id.replace("variant", "imagen"));  
    var Idimagesrc_ = document.getElementById(element.id.replace("variant", "imagen")).getAttribute("data-srcset"); 
    if (Idimagesrc_!="null"){
      Idimage_.srcset =Idimagesrc_ ;
    }
    $('.load1').removeAttr('srcset');
  };
  
  function dobleclick(element, url, divname, variant){     
    //Eliminar la selección de todos los colores del div
    var elm = {};
    var elms = document.getElementById("divcolor-"+ divname).getElementsByTagName("*");
    for (var i = 0; i < elms.length; i++) {  
      var x= document.getElementsByName(elms[i].name )[0];
      if (x != null){
        document.getElementsByName(elms[i].name )[0].classList.remove('active');   
      }
    }  
    //se aplica css al color seleccionado
    document.getElementsByName('variant-' + variant )[0].classList.add('active'); 
    document.getElementById('imagMain'+ element.id).href= url;  
    var Idimagesrc_ = document.getElementById(element.id.replace("variant", "imagen")); 
    Idimagesrc_.setAttribute("data-srcset",element.getAttribute("srcset"));
    
    if ((window.matchMedia("(max-width: 767px)").matches)) {
      if (element.touchtime == 0) {        
        element.touchtime = new Date().getTime();
      } else {       
        if (((new Date().getTime()) - element.touchtime) < 800) {
          element.touchtime = 0;
          element.href= url;              
          element.click();                        
        } else {     
          element.touchtime = new Date().getTime(); 
          element.removeAttribute("href");
        }
      } 

    }

  }
  
 